import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useApi } from '@elparking/utils'
import cancelBooking from 'commons/js/api/rentalCar/cancelBooking'
import SimpleModal from '../Modals/SimpleModal'
import CancelBookingModal from '../Modals/CancelBookingModal'
import { Button, Box, Flex } from '@elparking/components'
import { Edit } from '../Icons'
import useOnCloseModalAnalyticEvent from 'commons/js/hooks/useOnCloseModalAnalyticEvent'
import { RentalCarEvents, trackTealiumEvent } from 'commons/js/services/analytics'

const DefaultButton = ({ disableButton, onClick }) => <Button.unstyled
  dataTest='cancel-button-rental-car'
  borderRadius='3px'
  padding='1em 0.5em'
  fontSize='small'
  fontColor={disableButton ? 'gray80' : 'main'}
  height='auto'
  disabled={disableButton}
  width={['100%', '180px']}
  textTransform='none'
  fontWeight='medium'
  onClick={onClick}>
    <Flex gridGap='0.5em'>
        <Edit color={disableButton ? 'gray80' : 'main'} height='16px' />
        <FormattedMessage defaultMessage='Cancelar reserva' />
    </Flex>
</Button.unstyled>

DefaultButton.propTypes = {
    disableButton: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
}
DefaultButton.defaultProps = {
    disableButton: false,
}

const CancelButton = ({ onSuccess, cancelBooking, id, button: StyledButton, token, pageName }) => {
    const [ isModalShow, setIsModalShow ] = useState(false)
    const [ isModalErrorShow, setIsModalErrorShow ] = useState(false)

    useOnCloseModalAnalyticEvent(isModalShow, RentalCarEvents.showBookingDetail(pageName))
    const {
        response: { result, error },
        loading,
        sendRequest: cancel,
    } = useApi(cancelBooking)
    useEffect(() => {
        if (result && !error) {
            onSuccess(result)
        } else if (error) {
            setIsModalErrorShow(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [result, error])

    const disableButton = loading || error || result

    return <Box>
        <CancelBookingModal
          isShown={isModalShow}
          onClose={() => setIsModalShow(false)}
          pageName={pageName}
          onCancelBooking={() => {
                setIsModalShow(false)
                cancel({ id: id, token: token })
}
            }/>
        <SimpleModal
          isShown={isModalErrorShow}
          title={<FormattedMessage defaultMessage='No es posible cancelar la reserva' />}
          subtitle={<FormattedMessage defaultMessage='Puede intentarlo más tarde' />}
          onAccept={() => setIsModalErrorShow(false)}
          onClose={() => setIsModalErrorShow(false)}
          showCloseButton />
        <StyledButton
          disableButton={!!disableButton}
          onClick={() => {
                setIsModalShow(true)
                trackTealiumEvent(RentalCarEvents.eventCancelBookingConfirmBooking(pageName))
            }} />
    </ Box>
}

CancelButton.propTypes = {
    cancelBooking: PropTypes.func,
    onSuccess: PropTypes.func,
    id: PropTypes.any,
    button: PropTypes.func,
    token: PropTypes.string,
    pageName: PropTypes.string.isRequired,
}

CancelButton.defaultProps = {
    button: DefaultButton,
    cancelBooking,
    onSuccess: () => { },
}

export default CancelButton
